import PageHero from '../components/PageHero.jsx';
import SectionHeader from '../components/SectionHeader.jsx';
import { DONATE_URL, FISCAL_SPONSOR_URL } from '../support.js';

export default function FiscalSponsor() {
  return (
    <>
      <PageHero
        label="Fiscal sponsorship"
        title="Giving that supports the mission."
        intro="Power of One Foundation serves as the fiscal sponsor for Transformational Wellness Week San Francisco, helping manage giving so funds support the charity and cause."
      >
        <div className="button-row">
          <a className="button button--gold" href={DONATE_URL} target="_blank" rel="noopener noreferrer">Donate</a>
          <a className="button button--outline" href={FISCAL_SPONSOR_URL} target="_blank" rel="noopener noreferrer">Visit Power of One Foundation</a>
        </div>
      </PageHero>

      <section className="fiscal-sponsor section-pad">
        <div className="shell fiscal-sponsor__grid">
          <SectionHeader
            label="The connection"
            title="A charitable home for giving."
            body="The event team has designated Power of One Foundation as the fiscal sponsor for Transformational Wellness Week San Francisco. The foundation manages the donation process so support is directed to the charity and cause."
          />
          <aside className="fiscal-sponsor__campaign" aria-label="Official Transformational Wellness Week San Francisco support campaign">
            <p className="overline">Official campaign</p>
            <h2>One place to support the April 19-25, 2027 event.</h2>
            <p>The official campaign page is where supporters can donate, purchase event tickets, select sponsorship opportunities, and purchase magazine pages.</p>
            <a className="button button--gold" href={DONATE_URL} target="_blank" rel="noopener noreferrer">Donate or view support options</a>
          </aside>
        </div>
      </section>

      <section className="fiscal-sponsor__stewardship section-pad section-dark">
        <div className="shell fiscal-sponsor__stewardship-grid">
          <div>
            <p className="overline">Donation stewardship</p>
            <h2>Managed by Power of One Foundation.</h2>
          </div>
          <div>
            <p>Andre Roberson serves as Executive Director of Power of One Foundation and President of the K.E.E.N. Board. He helps manage giving for Transformational Wellness Week San Francisco through the foundation.</p>
            <p>All funds contributed through the official campaign are directed to the charity and cause.</p>
            <a className="button button--outline-light" href={FISCAL_SPONSOR_URL} target="_blank" rel="noopener noreferrer">Learn about Power of One Foundation</a>
          </div>
        </div>
      </section>
    </>
  );
}
